const signinConstants = {
  SIGNIN_IN_PROGRESS: "SIGNIN_IN_PROGRESS",
  SIGNIN_USER_SUCCESS: "SIGNIN_USER_SUCCESS",
  SIGNIN_USER_FAILURE: "SIGNIN_USER_FAILURE",
  SET_GUEST_EMAIL: "SET_GUEST_EMAIL",
  SIGNIN_USER_LOGOUT_SUCCESS: "SIGNIN_USER_LOGOUT_SUCCESS",
  SIGNIN_USER_LOGOUT_FAILURE: "SIGNIN_USER_LOGOUT_FAILURE",
  ACCOUNT_NAVIGATION_SHOW: "ACCOUNT_NAVIGATION_SHOW",
  ACCOUNT_NAVIGATION_HIDE: "ACCOUNT_NAVIGATION_HIDE",
  ACCOUNT_NAVIGATION_TOGGLED: "ACCOUNT_NAVIGATION_TOGGLED",
}

export default signinConstants
